import { apiRoute } from '../../constants/enum';
import { usePost } from '../../api/reactQueryCustomHooks';

// This will export a function to use handlers
export const useEInvoiceHandlers = () => {
  // ✅ Hook for GET Ewaybill Data
  const { mutate: getEwaybillData } = usePost({
    queryKey: 'getEinvoiceEwaybill',
    url: apiRoute.eInvoice.EwayBill,
    successMessage: '',
    resetValues: () => {},
    onSuccessTasks: async (resData) => {
      generateEwaybill({
        data: {
          aspid: resData.aspid,
          asppassword: resData.asppassword,
          gstin: resData.gstin,
          username: resData.username,
          authtoken: resData.authtoken,
          ewaybillData: resData.ewaybillData,
        },
      });
    },
  });

  // ✅ Hook for GENERATE Ewaybill
  const { mutate: generateEwaybill } = usePost({
    queryKey: 'generateEwaybill',
    url: apiRoute.eInvoice.EwayBillGenerate,
    successMessage: 'E-Waybill generated successfully!',
    resetValues: () => {},
    onSuccessTasks: async (resData) => {
      console.log('E-Waybill Generated:', resData);
      alert(`E-Waybill Generated: ${JSON.stringify(resData)}`);
    },
  });

  // ✅ Hook for GET EInvoice Data
  const { mutate: einvoicedata } = usePost({
    queryKey: 'getEinvoiceeinvoicedata',
    url: apiRoute.eInvoice.einvoicedata,
    successMessage: '',
    resetValues: () => {},
    onSuccessTasks: async (resData) => {
      generateEinvoicebill({
        data: {
          aspid: resData.aspid,
          asppassword: resData.asppassword,
          gstin: resData.gstin,
          username: resData.username,
          authtoken: resData.authtoken,
          einvoicebillData: resData.einvoicebillData,
        },
      });
    },
  });

  // ✅ Hook for GENERATE EInvoice
  const { mutate: generateEinvoicebill } = usePost({
    queryKey: 'generateEinvoicebill',
    url: apiRoute.eInvoice.generateEinvoicebill,
    successMessage: 'E-invoice generated successfully!',
    resetValues: () => {},
    onSuccessTasks: async (resData) => {
      console.log('E-Invoice Generated:', resData);
      alert(`E-Invoice Generated: ${JSON.stringify(resData)}`);
    },
  });

  // Now export the handlers
  const GenerateEwaybill = (payload) => {
    getEwaybillData({ data: payload });
  };

  const GenerateEinvoiceBill = (payload) => {
    einvoicedata({ data: payload });
  };

  return { GenerateEwaybill, GenerateEinvoiceBill };
};